import { Injectable } from '@angular/core';

import {Word} from '../../bayadic-shared-models/classes/word/Word';
import {Noun} from '../../bayadic-shared-models/classes/word/Noun';
import {Verb} from '../../bayadic-shared-models/classes/word/Verb';
import {Adjective} from '../../bayadic-shared-models/classes/word/Adjective';
import {Adverb} from '../../bayadic-shared-models/classes/word/Adverb';
import { WordObject } from '../../bayadic-shared-models/interfaces/word-object/WordObject';
import { WordsDatabaseService } from '../words-database-service/words-database-service';

@Injectable()
export class WordsManagerProvider {
    public words: Array<Word> =[];
    constructor(private wordsDatabaseService: WordsDatabaseService) {
        this.words = [];
    }
    public getSuggestions(word: string){
         return this.wordsDatabaseService.getSuggestions(word);
    }
    public saveWord(word : string){
        // this.wordsDatabaseMgr.insert(word);
    }
    public hasEnoughWordsSuggestions() : Promise<boolean>{
        return new Promise((resolve)=>{
            // this.wordsDatabaseMgr.getRowNumbers().then(rowNumbers=>{
            //     resolve(rowNumbers > 1000);
            // });
        })
    }
    public createWord(wordObject : WordObject) : Word{
        let word : Word;
        switch (wordObject.wordType){
            case Word.possibleTypes.noun : 
                word = new Noun(wordObject);
            break;
            case Word.possibleTypes.verb : 
                word = new Verb(wordObject);
            break;
            case Word.possibleTypes.adverb : 
                word = new Adverb(wordObject);
            break;
            case Word.possibleTypes.adjective : 
                word = new Adjective(wordObject);
            break;
        }
        word.setWordType(wordObject.wordType);
        return word;
    }
    public findWordType(wordObject : WordObject){
        let word : Word;
      
        if(this.isNoun(wordObject))
            word =  new Noun(wordObject);
        else if (this.isVerb())
            word = new Verb(wordObject);
        else
            word = new Word(wordObject);
       
        word.setUserID(wordObject.userID);
        return word;
    }
    isNoun(wordObject){
        return this.hasArtikel(wordObject) && this.hasPlural(wordObject) && !this.isNotFound(wordObject);
    }
    hasArtikel(wordObject : WordObject){
        return wordObject.artikel == "n" || wordObject.artikel == "m" || wordObject.artikel == "f";
    }
    hasPlural(wordObject : WordObject){
        return  wordObject.plural && wordObject.plural.length > 2;
    }
    isNotFound(wordObject : WordObject){
        return wordObject.translation && wordObject.translation.length == 0;
    }
    isPhrase(){

    }
    isVerb(){
        return true;
    }
 
}
